module.exports = __webpack_public_path__ + "static/media/taches.8a4a81ce.jpg";